module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "plates",
    attrs: {
      "id": "plates7"
    }
  }, [_c('p', {
    staticClass: "centerImage"
  }, [_c('img', {
    attrs: {
      "alt": "images",
      "id": "plate7",
      "src": "images/plate7.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Gerry Edge, right, flight commander with 605 when I joined, later to be CO of 253 Squadron before returning to 605 in late 1941.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2eaf85a5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/04_TallyHo_plates7.vue
// module id = 84
// module chunks = 0